module.exports = __webpack_public_path__ + "img/79683666.86c317ec.png";